










import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
import WebhookForm from "./Form.vue";
import { BrazeWebhookDto } from "@/store/braze-webhooks/braze-webhook.interface";
import Webhook from "@/store/braze-webhooks";

@Component({
  components: {
    "webhook-form": WebhookForm
  }
})
export default class AppWebhookCreate extends Vue {
  isLoading: boolean = false;
  error: any = "";

  async onSubmit(form: any) {
    this.error = "";
    this.isLoading = true;
    try {
      await Webhook.createOne(form);

      this.$router.back();
      this.isLoading = false;
      this.$toasted.success("Webhook Created");
    } catch (error) {
      this.isLoading = false;
      this.error = error.response.data.webhook;
      this.$toasted.error(this.error);
    }
  }

  async onCancel() {
    this.$router.back();
  }
}
